import React from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import { Socials, StrokeText } from "../components";
import { useMenu } from "../state";

const kebabCase = (string) => {
	return string
		.replace(/\s+/g, "-")
		.toLowerCase()
		.replace(/[^a-zA-Z0-9-_]/g, "");
};

/* Footer
============================================================================= */

const Footer = () => {
	// Config
	const { setPopupOpen } = useMenu();
	const data = useStaticQuery(
		graphql`
			query {
				sanityFooterNavigation {
					nav_items {
						title
					}
				}
			}
		`
	);

	// Render Menu Items
	const renderMenuItems = () => {
		return data.sanityFooterNavigation.nav_items.map((item) => {
			return (
				<MenuLink
					to={`/${kebabCase(item.title)}`}
					label={item.title}
					key={item.title}
				/>
			);
		});
	};

	// Render
	return (
		<footer className="relative z-30 flex flex-col items-center justify-start w-full px-10 py-16 bg-gtred md:flex-row md:items-start md:justify-between">
			<div className="flex flex-col items-start md:justify-between justify-center md:h-24 mt-2">
				<div className="relative z-50 flex flex-col items-center justify-start w-full space-y-4 md:space-x-6 md:space-y-0 md:block">
					{renderMenuItems()}
				</div>
				<div className="md:text-left text-center md:pt-0 pt-10 text-white font-light w-full">
					<p class="md:text-left text-center">
						&copy; 2022, Good Things
					</p>
				</div>
			</div>
			<div className="flex flex-col items-center justify-start md:items-end">
				<a
					className="mt-16 mb-6 cursor-pointer md:mt-0"
					target="_blank"
					rel="noopener noreferrer"
					href="https://goodthings2022.cc/gtf_website_footer-link_gen"
				>
					<StrokeText
						text="Buy Tickets"
						size="text-4xl"
						alignment="md:text-right text-center"
					/>
				</a>
				<Socials />
			</div>
		</footer>
	);
};

/* Menu Link
============================================================================= */

const MenuLink = ({ to = "/", label = "Home" }) => {
	// Config

	// Render
	return (
		<Link
			to={to}
			className="h-8 pt-6 pb-2 text-2xl leading-none tracking-wide text-white uppercase cursor-pointer phosphate"
		>
			{label}
		</Link>
	);
};

/* Export
============================================================================= */

export default Footer;
